import { render, staticRenderFns } from "./TicketDrawer.vue?vue&type=template&id=5b454aee"
import script from "./TicketDrawer.vue?vue&type=script&lang=js"
export * from "./TicketDrawer.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports